// extracted by mini-css-extract-plugin
export var errorIcon = "_nq-1";
export var nameLogo = "_nq-0";